import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b18f27a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "learn-container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title wow animate__backInDown" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  "data-wow-duration": "1s",
  class: "context animate__fadeInUp wow"
}
const _hoisted_6 = { class: "span1" }
const _hoisted_7 = { class: "right-container" }
const _hoisted_8 = {
  "data-wow-duration": "2s",
  class: "circles animate__animated animate__fadeInUp wow"
}
const _hoisted_9 = { class: "circle" }
const _hoisted_10 = { class: "num" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "circle" }
const _hoisted_13 = { class: "num" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "circle" }
const _hoisted_16 = { class: "num" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = {
  "data-wow-duration": "1s",
  class: "right animate__fadeInUp wow"
}

import WOW from 'wowjs'
import { onMounted, ref, watch } from "vue"
import { useWindowSize } from '@/views/Product/ProductPipeline/useWindowSize'

export default /*#__PURE__*/_defineComponent({
  __name: 'SecondView',
  setup(__props) {

const number1 = ref(30)
const number2 = ref(6000)
const number3 = ref(0)
const number4 = ref(4)
const isHover = ref(false)
const isEnd = ref(false)
const size = useWindowSize()
onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})
const changeIndex = () => {
  sessionStorage.setItem('activeIndex', '/about')
}
watch(size, (val) => {
  if (val.width < 768) {
    isEnd.value = true
  } else {
    isEnd.value = false
  }
})
document.addEventListener('DOMContentLoaded', function () {
  const circlesElement = document.querySelector('.circles')
  const eventTriggered = false

  function checkIfInView() {
    const elementRect = circlesElement.getBoundingClientRect()
    const elementInView = (elementRect.top >= 40 && elementRect.bottom <= window.innerHeight)

    if (elementInView && !eventTriggered) {
      // 在元素可视区域内且事件未被触发时执行事件
      // console.log('开始计数')

      const interval = setInterval(() => {
        // 数字递增到目标值
        number1.value = Math.min(number1.value + 30 / 10, 30)
        number2.value = Math.min(number2.value + 6000 / 10, 6000)
        // number3.value = Math.min(number3.value + 30 / 10, 30)
        number4.value = Math.min(number4.value + 4 / 3, 4)
        // 到达目标值后停止定时器

        if (number1.value === 6000 && number2.value === 30 && number4.value === 4) {
          clearInterval(interval)
        }
      }, 100)
    }
  }

  // 监听滚动事件
  window.addEventListener('scroll', checkIfInView)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('SubAboutus')), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('ABOUTUS')), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('aboutcontent')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(number4.value) + "+ ", 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Study')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(number2.value) + "+ ", 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('R&D laboratory')) + "(m³) ", 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(number1.value) + "+ ", 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Intellectual Property')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("a", {
        href: "/about",
        class: _normalizeClass(["learnmore", { 'animate__animated animate__rubberBand': isHover.value }]),
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
        onMouseout: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false)),
        onClick: changeIndex
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('learnmore')), 1)
      ], 34)
    ])
  ]))
}
}

})